import { Checkbox, CheckboxGroup, Flex, IconButton, Link, Menu, Portal, Text } from '@lego/klik-ui';
import { Filter, FilterBold } from '@lego/klik-ui/icons';
import type { RowData } from '@tanstack/react-table';
import type { Column } from '../appTable';

export const MultiSelectFilter = <T extends RowData>({ column }: { column: Column<T> }) => {
  const options =
    column.columnDef.meta?.filterVariant?.type === 'multiSelect' &&
    column.columnDef.meta?.filterVariant?.options;
  if (!options) return null;

  const filterValues = (column.getFilterValue() as unknown[]) ?? [];
  const handleCheckboxToggle = (toggledValue: unknown) => {
    const newFilterValues = filterValues.includes(toggledValue)
      ? filterValues.filter((value) => value !== toggledValue)
      : [...filterValues, toggledValue];
    column.setFilterValue(newFilterValues);
  };

  return (
    <Menu closeOnBlur closeOnSelect={false}>
      <Menu.Button as={Link} mr={2} tabIndex={0}>
        {filterValues.length === 0 || filterValues.length === options.length ? (
          <IconButton aria-label="Menu" icon={<Filter />} size="xs" variant="ghost" />
        ) : (
          <IconButton aria-label="Menu" icon={<FilterBold />} size="xs" variant="ghost" />
        )}
      </Menu.Button>
      <Portal>
        <Menu.List maxH="min(300px, calc(100dvh - 2rem))" overflowY="auto">
          <CheckboxGroup>
            {options.map(({ name, filterValue }) => (
              <Flex justifyContent="space-between" key={name} p={2}>
                <Text>{name}</Text>
                <Checkbox
                  isChecked={filterValues.includes(filterValue)}
                  onChange={() => {
                    handleCheckboxToggle(filterValue);
                  }}
                />
              </Flex>
            ))}
          </CheckboxGroup>
        </Menu.List>
      </Portal>
    </Menu>
  );
};
